module.exports = __webpack_public_path__ + "img/classic.ce57d3d1.svg";